import { MenuOpenReducer } from './MenuOpenReducer';
import { combineReducers } from 'redux';
import {BankReducer} from "./BankReducer";
import {UserReducer} from "./UserReducer";

export const Reducers = combineReducers({
  MenuOpenReducer,
  BankReducer,
  UserReducer
});